import PropTypes from 'prop-types';
import './PageHead.css';

// One meta item: mono label over value. Values never hide — a missing value
// renders as "—" (detail-shell rule: fields are always visible).
function MetaItem({ k, v, onClick }) {
  return (
    <div className="meta-item">
      <span className="meta-item__k">{k}</span>
      <span
        className={'meta-item__v' + (onClick ? ' meta-item__v--link' : '')}
        onClick={onClick}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
      >
        {v || '—'}
      </span>
    </div>
  );
}
MetaItem.propTypes = {
  k: PropTypes.string.isRequired,
  v: PropTypes.node,
  onClick: PropTypes.func,
};

// Page header — a mono kicker, a light display title, an optional sub
// line, a right-aligned actions slot, and an optional meta band (the
// detail-shell ladder: kicker → title+actions → sub → meta). Mirrors the
// prototype's PageHead/dhead. Use inside a `.page` screen.
export default function PageHead({ kicker, title, sub, action, meta }) {
  return (
    <div className="page-head">
      <div className="page-head__top">
        <div>
          {kicker && <div className="kicker">{kicker}</div>}
          <h1 className="page-title">{title}</h1>
        </div>
        {action && <div className="page-head__actions">{action}</div>}
      </div>
      {sub && <p className="page-sub">{sub}</p>}
      {meta && meta.length > 0 && (
        <div className="meta-row">
          {meta.map((m) => (
            <MetaItem key={m.k} k={m.k} v={m.v} onClick={m.onClick} />
          ))}
        </div>
      )}
    </div>
  );
}

PageHead.propTypes = {
  kicker: PropTypes.node,
  title: PropTypes.node.isRequired,
  sub: PropTypes.node,
  action: PropTypes.node,
  meta: PropTypes.arrayOf(
    PropTypes.shape({
      k: PropTypes.string.isRequired,
      v: PropTypes.node,
      onClick: PropTypes.func,
    }),
  ),
};
